import styled from "@emotion/styled";
import { colors } from "../../../styles/colors";
import { fonts } from "../../../styles/fonts";

export const Title = styled.h1`
  font-size: 48px;
  line-height: 57px;
  color: ${colors.GREY_DARK};
  font-family: ${fonts.abhayaBold};
  @media (max-width: 769px) {
    font-size: 36px;
    line-height: 42px;
    margin-bottom: 35px;
  }
`;

export const FirstHalf = styled.div`
  width: 100%;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (min-width: 769px) {
    margin-bottom: 5px;
    display: block;
    max-width: 47%;
    float: left;
    clear: left;
  }
`;
export const CookBookWrap = styled.section`
  max-width: 1261px;
  width: 100%;
  margin-top: 60px;
  overflow: hidden;

  @media (min-width: 769px) {
    display: block;
    margin: 56px auto 0;
    padding: 0 38px;
    padding-left: 6.8%;
    ${Title} {
      margin-bottom: 35px;
      float: left;
    }
  }
`;

export const Text = styled.p`
  color: ${colors.GREY_SEMIDARK};
  font-family: ${fonts.latoRegular};
  font-size: 16px;
  line-height: 27px;
  max-width: 380px;
  width: 100%;
  margin: 0;
  + p {
    margin-top: 20px;
  }
  @media (min-width: 769px) {
    font-size: 18px;
    margin-bottom: 20px;
    + p {
      margin-top: 0;
    }
  }
`;

export const TextTitle = styled.div`
  color: ${colors.GREY_DARK};
  font-family: ${fonts.latoRegular};
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  width: 390px;
  margin-bottom: 6px;
`;

export const FirstBox = styled.div``;
export const SecondBox = styled.div``;
export const SecondHalf = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
   margin: 0 -11px 0;
  @media (min-width: 769px) {
    float: right;
    max-width: 53.087%;
    width: 100%;
    margin: -37px -18px 0;
  }
  > div {
    margin-top: 15px;
    display: flex;
    position: relative;
    height: 246px;
    max-width: 50%;
    width: 100%;
    &:nth-child(odd){
      margin-top: 63px;
    }
    @media (max-width: 768px) and (min-width: 361px) {
      max-width: 164px;
    } 
    > * {
    margin: 0 11px !important;    
    @media (min-width: 769px) {
      margin: 0 18px !important;
    }
  }   
  @media (min-width: 769px) {
    padding: 70% 18px 0;
    height: 0;
    &:nth-child(odd){
      margin-top: 16.2%;
    }
  } 
  img {
    border-radius: 20px;
  }
  ${FirstBox}{
    margin-top: 63px;
    @media (min-width: 769px) {
    margin-top: 81px;
  }
`;
